/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import BaseInput from './BaseInput.vue';

/**
 * Base component to wrap hidden text inputs with a common markup.
 *
 * It has all `BaseInput` options
 *
 * @example
 *
 * base-input(:label="t('name')" type="text" v-model="form.name" validations="required" name="name")
 *
 * @category ui.components.form-elements
 * @exports HiddenInput
 * @component
 */
const __vue_script__ = {
    name: 'HiddenInput',

    extends: BaseInput,
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("control-decorator", {
    attrs: {
      label: _vm.label,
      tip: _vm.tip,
      hint: _vm.hint,
      uid: _vm.uid,
      errors: _vm.decoratorErrors,
      "hint-after-label": _vm.hintAfterLabel,
      warning: _vm.warning,
      dependant: _vm.dependant,
    },
    scopedSlots: _vm._u(
      [
        {
          key: "after-label",
          fn: function (ref) {
            return [_vm._t("after-label")]
          },
        },
        {
          key: "default",
          fn: function (ref) {
            var _obj
            return [
              _c(
                "div",
                {
                  staticClass: "input-wrapper",
                  class:
                    ((_obj = { "with-content": _vm.$slots.default }),
                    (_obj[_vm.wrapperClass] = _vm.wrapperClass),
                    _obj),
                },
                [
                  _vm.placeholderIconClass
                    ? _c("i", {
                        staticClass: "input-left-icon",
                        class: _vm.placeholderIconClass,
                      })
                    : _vm._e(),
                  _c(
                    "input",
                    _vm._g(
                      _vm._b(
                        {
                          ref: "input",
                          staticClass: "notranslate form-control",
                          class: {
                            "has-error": _vm.errors.length,
                            "has-warning": _vm.warning,
                            "with-icon": !!_vm.placeholderIconClass,
                          },
                          attrs: {
                            id: _vm.uid,
                            name: _vm.name,
                            type: _vm.type,
                            disabled: _vm.disabled,
                            placeholder: _vm.placeholder,
                            "aria-label":
                              _vm.placeholder && !_vm.label
                                ? _vm.placeholder
                                : null,
                            maxlength: _vm.maxlength,
                          },
                          domProps: { value: _vm.value },
                          on: { input: _vm.input, change: _vm.change },
                        },
                        "input",
                        _vm.inputAttrs,
                        false
                      ),
                      _vm.listeners
                    )
                  ),
                  _vm._t("default"),
                  _vm._t("extra"),
                ],
                2
              ),
            ]
          },
        },
        {
          key: "label-icon",
          fn: function (ref) {
            return [_c("i", { staticClass: "ic-icon icon-eye-with-line" })]
          },
        },
        {
          key: "inside-label",
          fn: function (ref) {
            return [_vm._t("inside-label")]
          },
        },
      ],
      null,
      true
    ),
  })
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/form-components/HiddenInput.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__